import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { doctosimg } from "../Constant/Index";

const MeetOurExpert = () => {
	return (
		<section className="meet-our-expert">
			<div className="container">
				<div className="row">
					<div className="col-lg-10 mx-auto">
						<div className="solve-detail-img extra-bg-8 radius-20 p-4">
							<div className="row align-items-center">
								<div className="col-lg-6 position-relative">
									<figure>
										<img src={doctosimg} className="img-fluid p-4" alt="" />
										<div
											className="play-icon"
											id="play-icon"
											data-bs-toggle="modal"
											data-bs-target="#videoModal"
										>
											<div className="wave"></div>
											<div className="wave"></div>
											<div className="wave"></div>
											<FontAwesomeIcon icon={faPlay} />
										</div>
									</figure>
								</div>

								<div
									className="modal fade"
									id="videoModal"
									tabIndex="-1"
									aria-labelledby="videoModalLabel"
									aria-hidden="true"
								>
									<div className="modal-dialog modal-dialog-centered">
										<div className="modal-content">
											<div className="modal-header">
												<h5 className="modal-title" id="videoModalLabel">
													Video Title
												</h5>
												<button
													type="button"
													className="btn-close"
													data-bs-dismiss="modal"
													aria-label="Close"
												></button>
											</div>
											<div className="modal-body">
												<video controls className="w-100">
													<source
														src="path/to/your/video.mp4"
														type="video/mp4"
													/>
													Your browser does not support the video tag.
												</video>
											</div>
										</div>
									</div>
								</div>

								<div className="col-lg-6">
									<div className="solved-heading pe-4">
										<h5 className="linear-bg-heading widht-wrapper mb-3 primary-regular-font">
											MEET OUR EXPERT
										</h5>
										<h3 className="main-heading-font dark-color level-3 wow animate__ animate__zoomIn animated">
											Dr. Preston White Akough-Weir, MD MBA
										</h3>
										<p className="primary-regular-font extra-color-5 level-7">
											Our health library is packed with the latest research and
											advice to keep you in the know about your well-being.
											Research and advice to keep you in the know about your
											well-being.
										</p>
										<Link
											to=""
											className="btn log-in level-7 primary-regular-font text-decoration-none"
										>
											<span className="bg-wrapper book-wrapper">
												Book Appointment
											</span>
										</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default MeetOurExpert;
